import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface SyncToZohoDialogData {
  pendingCount: number;
}

@Component({
  selector: 'app-sync-to-zoho-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './sync-to-zoho-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyncToZohoDialogComponent {
  data = inject<SyncToZohoDialogData>(MAT_DIALOG_DATA);
}
